import { TemplateCategoryTypes } from '../../types';
import { TemplateCategoryResponseTypes } from '../../types/response';

export const convertTemplateCategoryResponse = (
  item: TemplateCategoryResponseTypes
): TemplateCategoryTypes => {
  return {
    code: item.categoryCode,
    iconBgColor: item.backgroundColor,
    icon: item.icon,
  };
};
